import script from "./BaseSlider.vue?vue&type=script&setup=true&lang=js"
export * from "./BaseSlider.vue?vue&type=script&setup=true&lang=js"

import "./BaseSlider.vue?vue&type=style&index=0&id=6bef36a6&lang=scss"

const __exports__ = script;

export default __exports__